import { render, staticRenderFns } from "./RequestTypeFilter.vue?vue&type=template&id=578ea164&scoped=true"
import script from "@/components/request/RequestTypeFilter/RequestTypeFilter.ts?vue&type=script&lang=ts&external"
export * from "@/components/request/RequestTypeFilter/RequestTypeFilter.ts?vue&type=script&lang=ts&external"
import style0 from "@/components/request/RequestTypeFilter/request-type-filter.scss?vue&type=style&index=0&id=578ea164&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578ea164",
  null
  
)

export default component.exports